import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MapPinIcon } from '@heroicons/react/24/outline';

const ProvinceSelection = ({ onProvinceSelect, loading }) => {
  const [provinces, setProvinces] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProvinces();
  }, []);

  const fetchProvinces = async () => {
    try {
      setFetchLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/leagues`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const leagues = response.data.data || [];

      // Filter for leagues with 'rising' in the name (case-insensitive)
      const risingLeagues = leagues.filter(league =>
        /rising/i.test(league.name)
      );

      setProvinces(risingLeagues);
    } catch (err) {
      console.error('Fetch error:', err);
      setError('Failed to load provinces. Please try again.');
    } finally {
      setFetchLoading(false);
    }
  };

  const handleProvinceClick = (province) => {
    if (onProvinceSelect) {
      try {
        onProvinceSelect(province);
      } catch (e) {
        console.error('onProvinceSelect error:', e);
      }
    }
  };

  if (fetchLoading) {
    return (
      <div className="max-w-4xl mx-auto py-16">
        <div className="bg-gray-800 rounded-xl p-8 shadow-2xl text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4"></div>
          <p className="text-gray-300">Loading provinces...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto py-16">
        <div className="bg-gray-800 rounded-xl p-8 shadow-2xl text-center">
          <p className="text-red-400 mb-4">{error}</p>
          <button
            onClick={fetchProvinces}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto py-16 px-4">
      <div className="bg-gray-900 rounded-2xl p-8 shadow-lg">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-white">Rising Stars Registration</h1>
          <p className="text-gray-400 mt-2">Select your province to register for the Rising Stars league</p>
        </div>

        {provinces.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {provinces.map((province) => (
              <button
                key={province.leagueId}
                onClick={() => handleProvinceClick(province)}
                disabled={loading}
                className="bg-gray-800 hover:bg-gray-700 text-white rounded-xl p-6 shadow-lg transform transition hover:scale-105 disabled:opacity-50 flex flex-col items-center"
              >
                <MapPinIcon className="h-10 w-10 text-red-500 mb-3" />
                <h2 className="text-xl font-semibold">{province.name}</h2>
                <p className="text-sm text-gray-400 mt-2 text-center">
                  {province.description || 'No description available.'}
                </p>
                <div className="mt-4 text-sm text-gray-300">
                  Registration Fee: K{province.registrationFee ?? 210.0}
                </div>
              </button>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-400 py-12">
            No provinces available for registration at the moment.
          </div>
        )}
      </div>
    </div>
  );
};

export default ProvinceSelection;
